var map = {
	"./boho-1.jpg": 78552,
	"./boho-10.jpg": 6965,
	"./boho-11.jpg": 5867,
	"./boho-2.jpg": 91225,
	"./boho-3.jpg": 32386,
	"./boho-4.jpg": 63795,
	"./boho-5.jpg": 33148,
	"./boho-6.jpg": 66383,
	"./boho-7.jpg": 59900,
	"./boho-8.jpg": 45508,
	"./boho-9.jpg": 21742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43996;